module.exports = __webpack_public_path__ + "media/images/screenshots/board-df7b80ac1554f4f70e53f3cd64b2da99.png";